import React from "react";
import { Input, Row, Typography, Select, Form, Divider, Col } from "antd";
import { labelConfig, staticConfig } from "../../systemAdmin.config";
import { BOM } from "../../../../services/definedMethod";

const { Title } = Typography;

const BranchAuthorizationForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    officeData,
  } = props;
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={{
        allowTellerTillAuth: true,
        allowVaultTillAuth: true,
      }}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.authorizationInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.branch}
            name={"officeId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.branch),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.branch, "select")}
              options={officeData}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.tellerTillAuthorization}
            name={"allowTellerTillAuth"}
            // rules={[
            //   {
            //     required: true,
            //     message: "Required Field",
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              showSearch
              options={staticConfig.statusData}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.vaultAuthorization}
            name={"allowVaultTillAuth"}
            // rules={[
            //   {
            //     required: true,
            //     message: "Required Field",
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              showSearch
              options={staticConfig.statusData}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default BranchAuthorizationForm;
